import React from 'react';
import { HStack, Text } from '@chakra-ui/react';

interface PropertySelectorSectionHeaderProps {
	title: string;
	count: number;
}

const PropertySelectorSectionHeader: React.FC<PropertySelectorSectionHeaderProps> = (props) => {
	const { title, count } = props;

	return (
		<HStack gap={3}>
			<Text as="span" fontSize="xl" fontWeight="semibold">
				{title} ({count})
			</Text>
		</HStack>
	);
};

export default PropertySelectorSectionHeader;
